import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.bubble.css';
import DeleteIcon from '../../assets/Icons/DeleteIcon';
import EditIcon from '../../assets/Icons/EditIcon';
import moment from 'moment';
import { useAppDispatch } from '../../config/hooks';
import { deleteCommentapi } from '../../slices/salesSlice';
import { toast } from 'sonner';
import ConfirmationPopup from './ConfirmationPopup';
import Popup from '../../components/popup/Popup';
import CommentForm from './CommentForm';

const ReferencePoints = ({data}) => {
  const dispatch=useAppDispatch()
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [togglePopupComment, setTogglePopupComment] = useState(false);

  const handleDeleteComment = () => {
    dispatch(deleteCommentapi({id:data.id,clientId:data.clientId})) 
    toast.success("Comment successfully deleted")
  };

  const togglePopupCommentHandler = () => {
    setTogglePopupComment(!togglePopupComment);
  };
  return (
    <div className="relative py-2 px-2 flex justify-start ">
      <div className="bg-secondary-400/20 shadow-md rounded-lg min-w-[13rem] max-w-[13rem] min-h-[8rem] max-h-[8rem] overflow-y-auto no-scrollbar [&_.ql-editor]:p-2">
        {/* Left-side pointed tip */}
        <div className="absolute -left-0 top-4 w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-r-8 border-r-secondary-400/20"></div>
        <div className='flex items-center justify-between p-1'>
            <div className='text-xs text-exgray-500 font-semibold'>
                <h3>{moment(data.createdAt).format('DD/MM/YY')}</h3>
            </div>
            <div className='flex justify-end gap-3 '>
                <div
                 onClick={togglePopupCommentHandler}
                 className='cursor-pointer'
                >
                    <EditIcon height='15' color='#223870'/>
                </div>
                <div className='cursor-pointer'
                 onClick={() => setShowDeleteConfirm(true)}              
                >
                    <DeleteIcon height='15' color='#223870'/>
                </div>
            </div>
        </div>
        <ReactQuill
          value={
            data?.content
          }
          readOnly={true}
          theme="bubble"
          className="w-full h-fit text-left px-2 "
          modules={{ toolbar: false }}
        />

        <Popup
            visible={togglePopupComment}
            onClose={togglePopupCommentHandler}
            outsideClickClose={false}
            isCloseButton={true}
            children={
              <CommentForm
                togglePopupHandler={togglePopupCommentHandler}
                initialData={data}
                isUpdate={true}
              />
            }
          />

          <ConfirmationPopup
            visible={showDeleteConfirm}
            onClose={() => setShowDeleteConfirm(false)}
            onConfirm={handleDeleteComment}
            message="Are you sure you want to delete this comment?"
          />
      </div>
    </div>
  );
};

export default ReferencePoints;
